<div id=runningGames data-help="runningGames">
	<h1>Laufende Spiele</h1>
  <menu>
    <li><button class="btn-primary btn-primary-circle icon-refresh" onclick={refresh_runnings}>
      refresh
    </button></li>
  </menu>
	{#each games as game}
    <div class=gameCard class:running={true}>
      <h3 onclick={select_game.bind(game)}>{game.ID} – {game.name}</h3>
      <div class=contentBox>
        <img class=mapImg src={(game.cover) ? filepath_URL(game.cover) : "/static/images/missing.svg"} alt={game.ID}>
        <div class=gameInfo>
          <h4>Gruppe:</h4>
          <p>{game.fellowship}</p>
          {#if game.campaigne}
            <h4>Kampagne:</h4>
            <p>{game.campaigne}</p>
          {/if}
          <h4>Region:</h4>
          <p>{game.region} ({game.start})</p>
          <h4>Held:</h4>
          <p>{user.heroes.map(char => char.ID).filter(charID => game.heroes.includes(charID))?.join(", ")}</p>
        </div>
      </div>
      <p class=descript>{game.teaser}</p>
      <menu class="bar">
        <li><button class="btn-primary btn-primary-circle icon-play" onclick={join_game.bind(game)}>
          beitreten
        </button></li>
      </menu>
    </div>
	{/each}
</div>

<script>
  import {user, game, view, fetch_data, send_data} from "../client.svelte.js"
    import {filepath_URL} from "../core.js";
    import Select from "../elements/Select.svelte";

    let games = $derived(user.games.values().filter(game => game.adventure !== 'DEMO').toArray())

    // $inspect("GAMES-games", games)

    function select_game(e) {}

    function join_game(e) {
        user.join_game(this.ID)
	  }

    async function refresh_runnings() {
        await fetch_data(`/games`)
    }

</script>


<style>
    h1 {
        margin: 0.5em;
	}


	.gameCard {
        border: 1px solid grey;
        border-radius: 4px;
        background-color: #c60;
        margin: 8px;
	}

	.gameCard.running {
        background-color: #040; }

  .gameCard h3 {
      margin: 2ch  }

	.gameInfo {
        display: grid;
        grid-template-columns: 8ch auto;
        column-gap: 8px;
	}

  .gameInfo h4 {
    margin: 8px 0 4px 0;    }
  .gameInfo p {
    margin: 2px 0 4px 0;    }

	.contentBox {
        display: grid;
        grid-template-columns: 148px 28ch;
        column-gap: 8px;
	}

	.mapImg {
        width: 128px;
        height: 128px;
        justify-self: center;
        /*object-fit: contain;*/
	}

    .descript {
        margin: 12px;
    }

    button {
        background-color: darkgrey;
        border: black 1px solid;
        margin: 0 2.0em 0.5em 2.0em;
    }

</style>